import { GUIOverlay } from '@game-libs/gui-overlay';
import { GameGUI } from './game-gui';
import { GameStateProvider } from '../store/global-context';
import { DebugProvider, FlashOverlay, ZoomNormalizedContainer } from '@game-libs/exc-libs';

export const initGUI = () => {
  const { openOverlay } = GUIOverlay();

  openOverlay(
    <DebugProvider value={{ isEnabled: import.meta.env.VITE_IS_PROD === 'false', isDebug: true }}>
      <ZoomNormalizedContainer debug>
        <FlashOverlay />
        <GameStateProvider>
          <div id="ui-wrapper">
            <GameGUI />
          </div>
        </GameStateProvider>
      </ZoomNormalizedContainer>
    </DebugProvider>,
  );
};
